import { render, staticRenderFns } from "./EmojiComponent.vue?vue&type=template&id=b029d29c&scoped=true&"
import script from "./EmojiComponent.vue?vue&type=script&lang=js&"
export * from "./EmojiComponent.vue?vue&type=script&lang=js&"
import style0 from "./EmojiComponent.vue?vue&type=style&index=0&id=b029d29c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b029d29c",
  null
  
)

export default component.exports